import { ApplicationDataStore } from '../application/ApplicationDataStore';
import { DataItem, formatCurrency, Translate } from '@servicetitan/financing-utils-shared';
import { ReviewCard } from './ReviewCard';
import { useRef } from 'react';
import { ImperativeForm } from '../common/Form';
import { JobDetailsContainer } from '../job-details';
import { ResidenceOwnership2 } from '@servicetitan/financing-api-client';

export const JobDetails = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const jobDetails = applicationData?.applicant?.primaryApplicant?.jobDetails;
    const formRef = useRef<ImperativeForm>(null);
    const showMortgage = jobDetails?.residenceType === ResidenceOwnership2.OwnWithMortgage;

    return (
        <ReviewCard title="Job Details" formRef={formRef}>
            <ReviewCard.View>
                <DataItem label="Address Line 1" text={jobDetails?.address?.street} />
                {jobDetails?.address?.address2 && (
                    <DataItem label="Address Line 2" text={jobDetails?.address?.address2} />
                )}
                <DataItem label="City" text={jobDetails?.address?.city} />
                <DataItem label="State" text={jobDetails?.address?.state} />
                <DataItem label="Zip" text={jobDetails?.address?.zip} />
                <DataItem
                    label="Ownership Type"
                    text={Translate.residenceOwnership(jobDetails?.residenceType)}
                />
                {showMortgage && jobDetails?.mortgageMonthlyPayment && (
                    <DataItem
                        label="Estimated Monthly Mortgage Payment"
                        text={formatCurrency(jobDetails?.mortgageMonthlyPayment)}
                    />
                )}
                {showMortgage && jobDetails?.mortgageEstimatedBalance && (
                    <DataItem
                        label="Estimated Mortgage Balance"
                        text={formatCurrency(jobDetails?.mortgageEstimatedBalance)}
                    />
                )}
                <DataItem
                    label="Is Manufactured Home"
                    text={jobDetails?.isManufacturedHome ? 'Yes' : 'No'}
                />
            </ReviewCard.View>
            <ReviewCard.Edit>
                <JobDetailsContainer formRef={formRef} />
            </ReviewCard.Edit>
        </ReviewCard>
    );
};
